import {useOutletContext} from '@remix-run/react';
import {IRoute} from '~/types';
type ContextType = {
  homePageSections: any | null;
  menuItems?: IRoute[];
  headerStyle?: string;
  logo?: string;
  title?: string;
  isAuthenticated: boolean;
  articles?: any;
  collectionProducts?: any;
  allFaqs?: any;
  menu?: any;
};

export function useGetContext() {
  return useOutletContext<ContextType>();
}
